import { useEffect, useState } from 'react';

import { getTime, DateTime } from '@ping/utils';

/**
 * @method useCountdown
 * @description Hook to countdown from the provided number.
 * @param targetDate accepts a number in milliseconds
 */
const useCountdown = (targetDate: number) => {
  const [countdown, setCountdown] = useState(targetDate - DateTime.now());

  useEffect(() => {
    const interval = setInterval(() => {
      const current = targetDate - DateTime.now();
      if (current > 0) {
        setCountdown(current);
      } else {
        clearInterval(interval);
        setCountdown(0);
      }
    }, DateTime.seconds(1));

    return () => clearInterval(interval);
  }, [targetDate]);

  // Get the time in days, hours, minutes, etc.
  return getTime(countdown);
};

export { useCountdown };
